import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import exportTemplates from '@/components/DynamicComponents/exportTemplates'
import importTemplates from '@/components/DynamicComponents/importTemplates'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import ActionRenderer from '../../GridRenderer/actionRendere'
import {
  calculateGridHeight,
  showNotification,
  customComparator,
} from '@/services/calculate'
import CheckboxRender from '@/components/DynamicComponents/Renderers/checkboxRender'
import Pagination from '@/components/DynamicComponents/Pagination'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import { createRequest, tableName } from '@/services/config'

export default {
  components: {
    exportTemplates,
    importTemplates,
    'ag-grid-vue': AgGridVue,
    Pagination,
  },
  props: {
    tabKey: String,
    type: String,
    columnSettings: Array,
    screenId: Number,
    isArchive: Boolean,
  },
  data: function() {
    const checkLength = (rule, value, callback) => {
      const reg = /^(?!$)\d{0,8}(?:\.\d{1,2})?$/
      if (!reg.test(value)) {
        callback(new Error('Please enter valid life (e.g.: 12345678.12)'))
      } else {
        callback()
      }
    }
    const checkTextLength = (rule, value, callback) => {
      if (String(value).length > 100) {
        callback(
          new Error('Value must be less than or equals to 100 characters'),
        )
      } else {
        callback()
      }
    }
    return {
      exportClicked: false,
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: true,
      spinner: false,
      defaultSortedBy: 'assetClass',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      assetClassList: [],
      visible: false,
      modalTitle: '',
      form: {
        id: undefined,
        assetClass: undefined,
        description: undefined,
        defaultField: 'GDS',
        gdsLife: undefined,
        gdsMethod: undefined,
        gdsConvention: undefined,
        adsLife: undefined,
        adsMethod: undefined,
        adsConvention: undefined,
        isActive: 1,
      },
      rules: {
        assetClass: [
          {
            required: true,
            message: 'Please enter asset class Id',
            trigger: 'blur',
          },
          { validator: checkTextLength, trigger: 'blur' },
        ],
        description: [
          {
            required: true,
            message: 'Please enter asset class description',
            trigger: 'blur',
          },
          { validator: checkTextLength, trigger: 'blur' },
        ],
        defaultField: [
          {
            required: true,
            message: 'Please select default',
            trigger: 'change',
          },
        ],
        gdsLife: [
          { required: true, message: 'Please enter life', trigger: 'blur' },
          { validator: checkLength, trigger: 'blur' },
        ],
        gdsMethod: [
          { required: true, message: 'Please enter method', trigger: 'blur' },
          { validator: checkTextLength, trigger: 'blur' },
        ],
        gdsConvention: [
          {
            required: true,
            message: 'Please enter convention',
            trigger: 'blur',
          },
          { validator: checkTextLength, trigger: 'blur' },
        ],
        adsLife: [
          { required: true, message: 'Please enter life', trigger: 'blur' },
          { validator: checkLength, trigger: 'blur' },
        ],
        adsMethod: [
          { required: true, message: 'Please enter method', trigger: 'blur' },
          { validator: checkTextLength, trigger: 'blur' },
        ],
        adsConvention: [
          {
            required: true,
            message: 'Please enter convention',
            trigger: 'blur',
          },
          { validator: checkTextLength, trigger: 'blur' },
        ],
      },
      selectedRowKeys: [],
      loadRefresh: false,
      // gridOptions: null,
      // columnDefs: null,
      defaultColDef: null,
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      uploadedFile: null,
      importClicked: false,
      importColDef: [
        {
          checkboxSelection: this.checkboxSelection,
          headerCheckboxSelection: this.headerCheckboxSelection,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Asset Class',
          field: 'AssetClass',
          width: 100,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Description',
          field: 'Description',
          tooltipField: 'Description',
          width: 250,
        },
      ],
      loadImport: false,
      filters: {},
      updateRequest: null,
      requestKeys: [
        'assetClass',
        'description',
        'defaultField',
        'gdsLife',
        'gdsMethod',
        'gdsConvention',
        'adsLife',
        'adsMethod',
        'adsConvention',
        'isActive',
      ],
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        tooltipShowDelay: 0,
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      },
      columnDefs: [
        {
          field: 'checkbox',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 60,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Asset Class',
          field: 'assetClass',
          width: 100,
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          sort: 'asc',
          headerTooltip: 'Asset Class',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Description',
          field: 'description',
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          width: 250,
          headerTooltip: 'Description',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Default',
          field: 'defaultField',
          width: 75,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          suppressSizeToFit: true,
          headerTooltip: 'Default',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'GDS',
          marryChildren: true,
          children: [
            {
              field: 'gdsLife',
              filter: 'customFilter',
              cellRendererParams: { filter: 'dynamic', searchType: 'number' },
              headerName: 'Life',
              width: 100,
              suppressSizeToFit: true,
              headerTooltip: 'Life',
              cellRenderer: 'toolTipRenderer',
            },
            {
              field: 'gdsMethod',
              filter: 'customFilter',
              cellRendererParams: { filter: 'dynamic' },
              headerName: 'Method',
              width: 100,
              suppressSizeToFit: true,
              headerTooltip: 'Method',
              cellRenderer: 'toolTipRenderer',
            },
            {
              field: 'gdsConvention',
              filter: 'customFilter',
              cellRendererParams: { filter: 'dynamic' },
              headerName: 'Convention',
              width: 100,
              suppressSizeToFit: true,
              headerTooltip: 'Convention',
              cellRenderer: 'toolTipRenderer',
            },
          ],
          width: 300,
        },
        {
          headerName: 'ADS',
          marryChildren: true,
          children: [
            {
              field: 'adsLife',
              filter: 'customFilter',
              cellRendererParams: { filter: 'dynamic', searchType: 'number' },
              headerName: 'Life',
              width: 100,
              suppressSizeToFit: true,
              headerTooltip: 'Life',
              cellRenderer: 'toolTipRenderer',
            },
            {
              field: 'adsMethod',
              filter: 'customFilter',
              cellRendererParams: { filter: 'dynamic' },
              headerName: 'Method',
              width: 100,
              suppressSizeToFit: true,
              headerTooltip: 'Method',
              cellRenderer: 'toolTipRenderer',
            },
            {
              field: 'adsConvention',
              filter: 'customFilter',
              cellRendererParams: { filter: 'dynamic' },
              headerName: 'Convention',
              width: 100,
              suppressSizeToFit: true,
              headerTooltip: 'Convention',
              cellRenderer: 'toolTipRenderer',
            },
          ],
          width: 300,
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Asset Class',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ],
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.loadingConfig()
  },
  mounted() {
    this.$root.$on('deleteAssetClass', this.deleteAssetClass)
    this.$root.$on('editAssetClass', this.getAssetClassById)
    window.addEventListener('resize', this.getWindowSize)
  },
  beforeDestroy() {
    this.$root.$off('deleteAssetClass')
    this.$root.$off('editAssetClass')
    this.$off('updateTableData')
    window.removeEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '7') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.assetClassList = []
        this.loading = true
        this.defaultSortedBy =
          this.type !== 'Template' ? 'assetClass' : 'asset_Class'
        this.defaultSortOrder = true
        // this.gridOptions.columnApi.applyColumnState({
        //   state: [
        //     {
        //       colId: this.type !== 'Template' ? 'assetClass' : 'asset_Class',
        //       sort: 'asc',
        //     },
        //   ],
        //   defaultState: { sort: null },
        // })
        this.getAssetClasses(this.tableParams)
      }
    },
  },
  methods: {
    loadingConfig() {
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked || node.data.applicationId) return false
          else return true
        }
      }
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        checkboxCellRender: CheckboxRender,
        customFilter: CustomFilter,
        toolTipRenderer: ToolTipRenderer,
      }
    },

    // Refresh Asset Class
    refreshAssetClasses() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.assetClassList = []
      this.page = 0
      this.defaultSortedBy = 'assetClass'
      this.defaultSortOrder = true
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'assetClass',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.selectedRowKeys = []
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getAssetClasses(this.tableParams)
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Add New Asset Class
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New Asset Class'
      this.form.id = null
      this.form.asset_Class = undefined
      this.form.description = undefined
      this.form.defaultField = 'GDS'
      this.form.gdsLife = undefined
      this.form.gdsMethod = undefined
      this.form.gdsConvention = undefined
      this.form.adsLife = undefined
      this.form.adsMethod = undefined
      this.form.adsConvention = undefined
      this.isActive = 1
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Save Asset Class
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.form.id) {
            this.updateAssetClass()
          } else {
            this.addAssetClass()
          }
        }
      })
    },

    // Get Asset Class
    getAssetClasses(params, type) {
      const req = {
        pageSize: this.pageSize,
        currentPage: this.page,
        sortColumn: this.defaultSortedBy,
        isAscending: this.defaultSortOrder,
        assetClass: _.get(this.filters, 'assetClass', undefined),
        description: _.get(this.filters, 'description', undefined),
        defaultField: _.get(this.filters, 'defaultField', undefined),
        gdsLife: _.get(this.filters, 'gdsLife', undefined),
        gdsMethod: _.get(this.filters, 'gdsMethod', undefined),
        gdsConvention: _.get(this.filters, 'gdsConvention', undefined),
        adsLife: _.get(this.filters, 'adsLife', undefined),
        adsMethod: _.get(this.filters, 'adsMethod', undefined),
        adsConvention: _.get(this.filters, 'adsConvention', undefined),
      }
      instance
        .post(projectAPIs.master.assetClass.list(this.$route.params.id), req)
        .then(response => {
          this.assetClassList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'assetClassTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
          if (type === 'sort') {
            this.updateColumnSetting()
          } else {
            this.getColumnSettings(params)
          }
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    // Get Asset Class By Id
    getAssetClassById(id) {
      this.modalTitle = 'Edit'
      this.visible = true
      this.spinner = true
      instance
        .get(projectAPIs.master.assetClass.details(this.$route.params.id, id))
        .then(response => {
          this.form['id'] = _.get(response.data, 'result.id', null)
          this.form['description'] = _.get(
            response.data,
            'result.description',
            null,
          )
          this.form['assetClass'] = _.get(
            response.data,
            'result.assetClass',
            null,
          )
          this.form['defaultField'] = _.get(
            response.data,
            'result.defaultField',
            null,
          )
          this.form['gdsLife'] = Number(
            _.get(response.data, 'result.gdsLife', null),
          )
          this.form['gdsMethod'] = _.get(
            response.data,
            'result.gdsMethod',
            null,
          )
          this.form['gdsConvention'] = _.get(
            response.data,
            'result.gdsConvention',
            null,
          )
          this.form['adsLife'] = Number(
            _.get(response.data, 'result.adsLife', null),
          )
          this.form['adsMethod'] = _.get(
            response.data,
            'result.adsMethod',
            null,
          )
          this.form['adsConvention'] = _.get(
            response.data,
            'result.adsConvention',
            null,
          )
          this.form['isActive'] = _.get(
            response.data,
            'result.isActive',
            false,
          )
          this.updateRequest = _.get(response.data, 'result', null)
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const req = record ? [record.id] : this.selectedRowKeys
      instance
        .delete(projectAPIs.master.assetClass.delete(this.$route.params.id), {
          data: req,
        })
        .then(response => {
          showNotification(
            'success',
            'Delete Asset Class',
            'Asset Class deleted successfully!',
          )
          this.refreshAssetClasses()
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Delete All Asset Classes
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected asset classes ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected asset
              classes
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() {},
        class: 'test',
      })
    },

    // Delete Asset Class
    deleteAssetClass(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${data.assetClass}' ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to this asset
              class
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() {},
        class: 'test',
      })
    },

    downloadTemplate() {
      this.exportClicked = true
    },

    clickedCancel() {
      this.exportClicked = false
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function(s) {
          return s.sort != null
        })
        .map(function(s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.assetClassList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'assetClass'
        this.defaultSortOrder = true
      }
      this.tableState = this.gridOptions.columnApi.getColumnState()
      this.getAssetClasses(this.tableParams, 'sort')
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    beforeUpload(file) {
      const isValid =
        file.type === 'xlsx' ||
        file.type === 'xls' ||
        file.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (!isValid) {
        showNotification('error', 'Import', 'Please upload excel file only!')
      }
      return isValid
    },

    handleImport(event) {
      this.importClicked = true
      this.uploadedFile = event.file
      this.loadImport = true
    },

    clickedCancelimport(addedCount) {
      this.importClicked = false
      this.loadImport = false
      if (addedCount > 0) {
        this.refreshAssetClasses()
      }
    },

    updateTable() {
      this.importClicked = false
      this.refreshAssetClasses()
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'assetClassTable',
        this.count > this.pageSize,
      )
      this.getColumnSettings(this.gridOptions)
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.assetClassList = []
      this.selectedRowKeys = []
      this.getAssetClasses(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.loading = true
      this.page = 0
      this.assetClassList = []
      this.getAssetClasses(this.gridOptions)
    },

    // Add asset class
    addAssetClass() {
      this.spinner = true
      instance
        .post(
          projectAPIs.master.assetClass.add(this.$route.params.id),
          this.form,
        )
        .then(response => {
          this.spinner = false
          if (response.data.message) {
            showNotification('warning', 'Asset Class', response.data.message)
          } else {
            this.visible = false
            showNotification(
              'success',
              'Create Asset Class',
              'Asset Class created successfully!',
            )
            this.getAssetClasses(this.tableParams)
            this.$refs.ruleForm.resetFields()
          }
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    // Update asset class
    updateAssetClass() {
      const req = createRequest(
        this.requestKeys,
        this.updateRequest,
        this.form,
      )

      if (!req.isValid) {
        showNotification(
          'info',
          'Update Asset Class',
          'No changes found to update!',
        )
        return
      }
      this.spinner = true
      instance
        .patch(
          projectAPIs.master.assetClass.details(
            this.$route.params.id,
            this.form.id,
          ),
          req.request,
        )
        .then(response => {
          this.spinner = false
          if (response.data.message) {
            showNotification('warning', 'Asset Class', response.data.message)
          } else {
            this.visible = false
            showNotification(
              'success',
              'Update Asset Class',
              'Asset Class updated successfully!',
            )
            const newData = [...this.assetClassList]
            const index = newData.findIndex(i => i.id === this.form.id)
            newData[index]['id'] = this.form.id
            newData[index]['description'] = this.form.description
            newData[index]['assetClass'] = this.form.assetClass
            newData[index]['defaultField'] = this.form.defaultField
            newData[index]['gdsLife'] = this.form.gdsLife
            newData[index]['gdsMethod'] = this.form.gdsMethod
            newData[index]['gdsConvention'] = this.form.gdsConvention
            newData[index]['adsLife'] = this.form.adsLife
            newData[index]['adsMethod'] = this.form.adsMethod
            newData[index]['adsConvention'] = this.form.adsConvention
            this.assetClassList = newData
            this.$refs.ruleForm.resetFields()
          }
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    getColumnSettings(params) {
      const columnDetails = this.columnSettings.find(
        i =>
          i.screenId === this.screenId &&
          i.tableName === tableName.project.master.assetClass,
      )
      if (columnDetails && columnDetails.columnDetails) {
        const tableState = JSON.parse(columnDetails.columnDetails)
        this.gridOptions.columnApi.applyColumnState({
          state: tableState,
          applyOrder: true,
        })
      } else {
        if (params) {
          this.tableParams = null
          this.tableParams = params
          params.api.sizeColumnsToFit()
        }
      }
      params.columnApi.applyColumnState({
        state: [
          {
            colId: 'checkbox',
            hide: this.isArchive,
          },
          {
            colId: 'action',
            hide: this.isArchive,
          },
        ],
      })
      if (this.isArchive) {
        if (params) {
          this.tableParams = null
          this.tableParams = params
          params.api.sizeColumnsToFit()
        }
      }
    },

    updateColumnSetting() {
      const tableState = this.gridOptions.columnApi.getColumnState()
      const request = {
        screenId: this.screenId,
        tableName: tableName.project.master.assetClass,
        columnDetails: JSON.stringify(tableState),
      }
      if (!this.isArchive) {
        this.$emit('updateColumnSettings', request)
      }
    },

    onColumnResized(e) {
      if (e.finished) {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        this.updateColumnSetting()
      }
    },
  },
}
